export enum RatingAndReviewsTypesModel {
  InlineRating = 'INLINE_RATING',
  RatingSummary = 'RATING_SUMMARY',
  Reviews = 'REVIEWS'
}

export interface RatingAndReviewsModelProps {
  gcode?: string
  type?: RatingAndReviewsTypesModel
}
